export default {
  label_ev_issuer_demo_message:
    'DE_ABN AMRO e-Vest is the platform for issuers to administrate and review their share incentive schemes and share register. Please contact your account manager for more information.',
  label_ev_no_sppts_found: 'DE_No participations found',
  label_ev_no_sppts_found_query:
    'DE_No participations found for the given query',
};
